import script from "./SegmentCountersWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./SegmentCountersWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./SegmentCountersWrapper.vue?vue&type=style&index=0&id=56ddb262&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56ddb262"]])

export default __exports__